import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { monitor } from '../../store/actions';
import * as apps from '../../enums/apps';
import ScrollWrapper from '../ScrollWrapper';
import DrawerFooter from '../DrawerFooter';
import DrawerHeader from '../DrawerHeader';
import './style.scss';

const shownIncrements = 10;

class TabsWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: props.defaultOpenInbox ? apps.APP_NAME_INBOX : apps.APP_NAME_NOTIFICATIONS,
            shownCount: shownIncrements,
        };

        this.showMore = this.showMore.bind(this);
        this.setActive = this.setActive.bind(this);
    }

    showMore() {
        this.setState({ shownCount: this.state.shownCount + shownIncrements });
    }

    setActive(e, active) {
        this.setState({ active });
        this.props.monitor(active, 'tab_switch');
    }

    render() {
        const { active, shownCount } = this.state;
        const { username, className, notificationSoundEnabled, drawerType } = this.props;

        return (
            <section className={classNames(className, 'wrapper')}>
                <DrawerHeader drawerType={drawerType} active={active} onClick={this.setActive} />
                <ScrollWrapper
                    active={active}
                    shownCount={shownCount}
                    showMore={this.showMore}
                    drawerType={drawerType}
                />
                <DrawerFooter active={active} notificationSoundEnabled={notificationSoundEnabled} username={username} />
            </section>
        );
    }
}

TabsWrapper.propTypes = {
    monitor: propTypes.func,
    defaultOpenInbox: propTypes.bool,
    notificationSoundEnabled: propTypes.bool,
    username: propTypes.string,
    drawerType: propTypes.string,
    className: propTypes.string,
};

TabsWrapper.defaultProps = {
    preventCloseAction: () => null,
};

export default connect(null, { monitor })(TabsWrapper);
